import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const ActionService = {
    options: async () => axios.get(API_URL + "/actions/options").then(({data}) => data).catch(err => { throw err }),
};

export default ActionService;